import {forwardRef} from 'react'
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome'
import {IconProp} from '@fortawesome/fontawesome-svg-core'

type FAIconProps = {
  icon: IconProp
  className?: string
  onClick?: () => void
  title?: string
  defaultClassnameApply?: boolean
  onMouseEnter?: () => void
  onMouseLeave?: () => void
}

const FAIcon = forwardRef<SVGSVGElement, FAIconProps>(
  (
    {
      icon,
      className = '',
      onClick,
      title,
      defaultClassnameApply = true,
      onMouseEnter,
      onMouseLeave,
    },
    ref
  ) => {
    const combinedClassName = `${defaultClassnameApply && 'font-awesome-icon'} ${
      onClick ? 'cursor-pointer' : ''
    } ${className}`.trim()

    return (
      <FontAwesomeIcon
        icon={icon}
        className={combinedClassName}
        onClick={onClick}
        title={title}
        ref={ref}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
      />
    )
  }
)

export default FAIcon
